import { ENV } from "./envs"; export const defaultEnv: ENV = ENV.PREPROD;
